import Repository from './Repository';
import { NSBanner } from '@/types/Banner';

export default {
  async get(resource: string) {
    return Repository.get<NSBanner.IBannerJSON>(resource, {
      timeout: 1000
    });
  }
};
